import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const DIALOG_NAME = "Select";
const [DialogProvider, useDialogContext] = buildGlobalReferenceContext(DIALOG_NAME);

export { DialogProvider, useDialogContext };
//# sourceMappingURL=context.mjs.map
